import { ApiModel, ListingBuyerModel, ListingBuyerModelConverter } from '@steelbuy/ts-shared';
import { usePaginatedQuery } from '../../utils/usePaginatedQuery';

export const RFQ_MATCHES_KEY = 'quotes-matches';

const modelConverter = new ListingBuyerModelConverter();
const matchedListingMapFn = (data: ListingBuyerModel) =>
    modelConverter.toViewModel(data as unknown as ApiModel<ListingBuyerModel>);

export const useRFQMatchedListings = (quoteId: string, { queryOptions } = { queryOptions: { enabled: true } }) =>
    usePaginatedQuery<ListingBuyerModel>({
        url: `/api/buyer/quotes/${quoteId}/matches`,
        mapFn: matchedListingMapFn,
        requestOptions: {},
        queryKey: [RFQ_MATCHES_KEY],
        queryOptions: {
            refetchOnMount: false,
            enabled: queryOptions.enabled,
            cacheTime: 0,
        },
    });
